import React, { Component } from "react";
import { Wrapper, Copy } from "app/NativeComponents/common";
import MessageAndNoteBox from "app/DealMachineCore/snippets/MessageAndNoteBox";
import MessageHeader from "./MessageHeader";
import MessageDisplay from "./MessageDisplay";
import SendButton from "./SendButton";

class SendMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderMessageBox() {
    const { multisend_number, colors } = this.props;
    if (
      (multisend_number.lead_phone_number &&
        (multisend_number.lead_phone_number.bad_phone == 1 ||
          multisend_number.lead_phone_number.blocked == 1 ||
          multisend_number.lead_phone_number.do_not_call == 1 ||
          multisend_number.lead_phone_number.timezone_lock_out ||
          multisend_number.lead_phone_number.landline == 1)) ||
      multisend_number.awaiting_response_lock_out ||
      multisend_number.received_response ||
      multisend_number.timezone_lock_out
    ) {
      if (multisend_number.awaiting_response_lock_out) {
        return (
          <Wrapper
            style={{
              backgroundColor: colors.card_color,
              padding: 20,
              paddingBottom: 10,
              borderTopWidth: 1,
              borderTopStyle: "solid",
              borderTopColor: colors.border_color
            }}
          >
            <Copy style={{ textAlign: "center" }}>
              Conversation Locked. You must wait for the lead to respond or wait
              30 days.
            </Copy>
          </Wrapper>
        );
      }

      if (
        multisend_number.timezone_lock_out ||
        multisend_number.lead_phone_number.timezone_lock_out
      ) {
        return (
          <Wrapper
            style={{
              backgroundColor: colors.card_color,
              padding: 20,
              paddingBottom: 10,
              borderTopWidth: 1,
              borderTopStyle: "solid",
              borderTopColor: colors.border_color
            }}
          >
            <Copy style={{ textAlign: "center" }}>
              The current time is outside of the TCPA hours for this area.
            </Copy>
          </Wrapper>
        );
      }

      if (multisend_number.received_response) {
        return (
          <Wrapper
            style={{
              backgroundColor: colors.card_color,
              padding: 20,
              paddingBottom: 10,
              borderTopWidth: 1,
              borderTopStyle: "solid",
              borderTopColor: colors.border_color
            }}
          >
            <Copy style={{ textAlign: "center" }}>
              You've already recieved a response from this phone number.
            </Copy>
          </Wrapper>
        );
      }
      return <Wrapper />;
    }
    return (
      <MessageAndNoteBox
        box_tab={"message"}
        selected_conversations={this.props.active_conversation}
        include_tabs={false}
        disabled={true}
        multisend={true}
        onNoteSubmit={() => {}}
        messageValue={this.props.current_message_text}
        onMessageChange={message => {
          this.props.updateCurrentMessageText(message);
        }}
        onFromNumberChange={phone_number => {
          this.props.updateCurrentFromNumber(phone_number);
        }}
        onMessageSubmit={() => {}}
        selected_from_number={this.props.selected_from_number}
      />
    );
  }

  render() {
    const {
      started_sending,
      multisend_number,
      sending_over,
      multisend_numbers_loading
    } = this.props;
    if (started_sending && multisend_number && !sending_over) {
      return (
        <Wrapper style={{ flex: 1, display: "flex" }}>
          <MessageHeader
            multisend_number={this.props.multisend_number}
            {...this.props}
          />

          <MessageDisplay {...this.props} />
          <Wrapper
            style={{
              position: "absolute",
              bottom: 0,
              paddingBottom: this.props.isIphoneX ? 20 : 0,
              backgroundColor: this.props.colors.card_color,
              left: 0,
              right: 0
            }}
          >
            {this.renderMessageBox()}
            <SendButton
              {...this.props}
              started_sending={this.props.started_sending}
              multisend_number={this.props.multisend_number}
              current_message_text={this.props.current_message_text}
              startSending={this.props.startSending}
              sending_over={this.props.sending_over}
              selected_from_number={this.props.selected_from_number}
            />
          </Wrapper>
        </Wrapper>
      );
    }
    if (!sending_over) {
      return (
        <Wrapper
          style={{
            position: "absolute",
            bottom: 0,
            paddingBottom: this.props.isIphoneX ? 20 : 0,
            left: 0,
            right: 0
          }}
        >
          <SendButton
            {...this.props}
            started_sending={this.props.started_sending}
            multisend_number={this.props.multisend_number}
            current_message_text={this.props.current_message_text}
            startSending={this.props.startSending}
            sending_over={this.props.sending_over}
            selected_from_number={this.props.selected_from_number}
          />
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default SendMessage;
